/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['connectionSalesTypes', 'items', id], null);